import React, { useState } from 'react';
import './KakaoChat.css';

const KakaoChat = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleChat = () => {
    setIsVisible(!isVisible);
  };

  const handleKakaoChat = () => {
    const now = new Date();
    const day = now.getDay(); // 0: 일요일, 1: 월요일, ..., 6: 토요일
    const hour = now.getHours();
    
    // 평일(월~금) 11시~16시 체크
    const isWeekday = day >= 1 && day <= 5;
    const isBusinessHour = hour >= 11 && hour < 16;
    
    if (isWeekday && isBusinessHour) {
      // 상담 가능 시간: 카카오톡 채널로 연결
      window.open('https://pf.kakao.com/_gazxmG/chat', '_blank');
    } else {
      // 상담 불가 시간: 안내 메시지
      alert('카카오톡 상담 가능 시간은 평일 11:00~16:00입니다.\n\n평일 11시부터 16시 사이에 다시 연락해 주시기 바랍니다.\n\n급하신 경우 전화상담(02-6949-5003) 또는 이메일(tax_gyeol@naver.com)을 이용해 주세요.');
    }
  };

  return (
    <div className="kakao-chat">
      <div className={`chat-options ${isVisible ? 'visible' : ''}`}>
        <div className="chat-option" onClick={handleKakaoChat}>
          <div className="chat-icon kakao">
            <span>💬</span>
          </div>
          <span>카카오톡 상담</span>
        </div>
        <div className="chat-option" onClick={() => window.location.href = 'tel:02-6949-5003'}>
          <div className="chat-icon phone">
            <span>📞</span>
          </div>
          <span>전화 상담</span>
        </div>
      </div>
      
      <button 
        className="chat-toggle"
        onClick={toggleChat}
        aria-label="상담 메뉴"
      >
        <span className={`chat-icon ${isVisible ? 'close' : 'open'}`}>
          {isVisible ? '✕' : '💬'}
        </span>
      </button>
    </div>
  );
};

export default KakaoChat;
